<!--
 * 飞书扫码登录回调页
 *
 * 弹窗授权流程的落点:飞书授权后重定向到 /feishu/third_party_login?code=xxx,
 * 本页用一次性 code 换取登录态(session cookie 已由同域请求种下),
 * 再 postMessage 通知发起登录的原窗口刷新用户信息,最后自动关闭弹窗。
-->
<template>
  <div class="feishu-callback">
    <a-spin :spinning="loading">
      <div class="card">
        <img class="logo" src="@/assets/image/logo_feishu.png" alt="飞书" />
        <div class="msg">{{ message }}</div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import { feishuLogin } from '@/api/base/user';

export default {
  name: 'FeiShuCallback',
  data() {
    return {
      loading: true,
      message: '飞书登录中，请稍候…',
    };
  },
  created() {
    this.doLogin();
  },
  methods: {
    async doLogin() {
      const code = new URLSearchParams(window.location.search).get('code');
      if (!code) {
        this.fail('缺少授权码，请回到登录页重新点击飞书登录');
        return;
      }
      try {
        const data = await feishuLogin({ code });
        if (data.code === 0) {
          if (window.opener) {
            this.message = '登录成功，正在返回…';
            window.opener.postMessage('feishu_login_success', window.location.origin);
            setTimeout(() => window.close(), 600);
          } else {
            // 非弹窗直接访问本页时 window.close() 无效,提示手动前往
            this.loading = false;
            this.message = '登录成功，请关闭本页后回到系统继续操作';
          }
        } else {
          this.fail(data.msg || '登录失败，请重试');
        }
      } catch (e) {
        this.fail('登录失败，请重试');
      }
    },
    fail(msg) {
      this.loading = false;
      this.message = msg;
    },
  },
};
</script>

<style lang="less" scoped>
.feishu-callback {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f4f8;

  .card {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 56px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);

    .logo {
      width: 2.5rem;
      height: 2.5rem;
      margin-bottom: 16px;
    }

    .msg {
      color: #333;
      font-size: 14px;
      min-width: 200px;
      text-align: center;
    }
  }
}
</style>
